import React, { useState } from 'react'

import { useMetricCategories } from 'redux/hooks/Categories'
import { useQuery } from 'utils/hooks'
import { useTranslation } from 'language/translator'

import EntitiesList from 'components_new/organisms/EntitiesList'
import EntitiesListHero from 'components_new/organisms/EntitiesListHero'

import PageLayout from 'components_new/templates/PageLayout'

const Entities = () => {
  const categories = useMetricCategories()
  const { query, setQuery } = useQuery()
  const { lang, t } = useTranslation()

  const [searchTerm, setSearchTerm] = useState<string | null>(null)

  const category = query['category'] || null

  return (
    <PageLayout
      content={{
        hero: (
          <EntitiesListHero
            category={category}
            setCategory={(value) =>
              setQuery({ category: value, subcategory: null })
            }
            search={searchTerm}
            setSearch={setSearchTerm}
          />
        )
      }}
      topbar={{
        breadcrumbs: [
          {
            href: '/entities',
            icon: { name: 'Entities' },
            title: t('entities', 'entities')
          },
          ...(category
            ? [
                {
                  href: '/entities',
                  icon: { name: 'Folder' as const },
                  search: `?category=${category}`,
                  title: categories[category]?.title[lang]
                }
              ]
            : [])
        ]
      }}
      variant="static"
    >
      <EntitiesList category={category} search={searchTerm} />
    </PageLayout>
  )
}

export default Entities
